import { LABEL } from '@veriables';

const KEYS = {
  ALL_CHECKS: 'allChecks',
  OPEN_CHECKS: 'openChecks',
  LOYALTY_ACCOUNT_BALANCE: 'loyaltyAccountBalance',
  GIFT_BALANCE: 'giftBalance',
  GAME_CARD_BALANCE: 'gameCardBalance',
  LAUNCH_EXTERNAL_APP: 'lauchExternalApp',
  OFFLINE_PAYMENT: 'offlinePayment',
  TIP_ONLY: 'tipOnly',
  CHANGE_JOB: 'changeJobType',
  CASH_OUT: 'cashOut',
  ABOUT: 'about',
};

const MENU_BUTTONS = [
  {
    id: 1,
    key: KEYS.ALL_CHECKS,
    label: LABEL().ALL_CHECKS,
  },
  {
    id: 2,
    key: KEYS.OPEN_CHECKS,
    label: LABEL().OPEN_CHECKS,
  },
  {
    id: 3,
    key: KEYS.LOYALTY_ACCOUNT_BALANCE,
    label: LABEL().LB_LOYALTY_BALANCE,
  },
  {
    id: 4,
    key: KEYS.GIFT_BALANCE,
    label: LABEL().GIFT_BALANCE,
  },
  {
    id: 5,
    key: KEYS.GAME_CARD_BALANCE,
    label: LABEL().GAME_CARD_BALANCE,
  },
  {
    id: 6,
    key: KEYS.LAUNCH_EXTERNAL_APP,
    label: '',
  },
  {
    id: 7,
    key: KEYS.OFFLINE_PAYMENT,
    label: LABEL().HAMBURGER_OFFLINE_PAYMENT,
  },
  {
    id: 8,
    key: KEYS.TIP_ONLY,
    label: LABEL().TIP_ONLY,
  },
  {
    id: 9,
    key: KEYS.CHANGE_JOB,
    label: LABEL().CHANGE_JOB,
  },
  {
    id: 10,
    key: KEYS.CASH_OUT,
    label: LABEL().CASH_OUT,
  },
  {
    id: 11,
    key: KEYS.ABOUT,
    label: LABEL().ABOUT,
  },
];

export { MENU_BUTTONS, KEYS };
